// extracted by mini-css-extract-plugin
module.exports = {"popover":"popover--3iS-X"};